import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { LoginComponent } from './features/auth/login/login.component';
import { RegisterComponent } from './features/auth/register/register.component';
import { OtpVerificationComponent } from './features/auth/otp-verification/otp-verification.component';
import { SetPasswordComponent } from './features/auth/set-password/set-password.component';
import { EmailVerificationComponent } from './features/auth/email-verification/email-verification.component';
import { ForgotPasswordComponent } from './features/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './features/auth/reset-password/reset-password.component';
import { NewAnnouncementComponent } from './features/announcements/new-announcement/new-announcement.component';
import { authGuard } from './core/auth/guards/auth.guard';
import { AnnouncementDetailComponent } from './features/announcements/announcement-detail/announcement-detail.component';
import { ProfileLayoutComponent } from './features/profile/profile-layout.component';
import { MyProfileComponent } from './features/profile/my-profile/my-profile.component';
import { MyRequestsComponent } from './features/profile/my-requests/my-requests.component';
import { MyAdsComponent } from './features/profile/my-ads/my-ads.component';
import { MyBalanceComponent } from './features/profile/my-balance/my-balance.component';
import { PaymentHistoryComponent } from './features/profile/payment-history/payment-history.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'otp-verification', component: OtpVerificationComponent },
  { path: 'set-password', component: SetPasswordComponent },
  { path: 'email-verification', component: EmailVerificationComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'announcements/new', component: NewAnnouncementComponent },
  { path: 'announcements/edit/:id', component: NewAnnouncementComponent, canActivate: [authGuard] },
  { path: 'announcements/:id', component: AnnouncementDetailComponent },
  { path: 'listings/:id', component: AnnouncementDetailComponent },
  {
    path: 'profile',
    component: ProfileLayoutComponent,
    children: [
      { path: '', redirectTo: 'my-profile', pathMatch: 'full' },
      { path: 'my-profile', component: MyProfileComponent },
      { path: 'my-requests', component: MyRequestsComponent },
      { path: 'my-ads', component: MyAdsComponent },
      { path: 'my-balance', component: MyBalanceComponent },
      { path: 'payment-history', component: PaymentHistoryComponent }
    ]
  },
  {
    path: 'payment',
    loadChildren: () => import('./features/payment/payment.routes').then(m => m.PAYMENT_ROUTES)
  },
  { path: '**', redirectTo: '' }
];
